/* AKKURANDO – Hub „Akkunaut-Welt“ (Präfix ake, Handbuch Kap. 6). Lädt nicht das Spiel.
   1. Countdown „nächster Anlass in X Tagen“ im Browser nachrechnen (Seiten-Cache, Europe/Berlin).
   2. Anlass-Dialoge (heute und Archiv): <template data-ake-dlg="id"> erst auf Klick in die Seite holen, CSS des Anlasses
      nachladen, Interaktion wie im Anlass-Modul starten (window.AKAN.registriere, gleiche Schnittstelle wie assets/akk-anlass.js).
   3. Messereignisse über Shopify.analytics.publish (GA4-Namensschema), Protokoll in window.AKE_LOG. */
(() => {
  'use strict';
  const root = document.querySelector('[data-ake-welt]');
  if (!root || root.dataset.akeReady) return;
  root.dataset.akeReady = '1';
  const de = document.documentElement;
  const AKAN = window.AKAN = window.AKAN || { _reg: {}, _warte: {}, registriere(name, start) { this._reg[name] = start; if (this._warte[name]) this._warte[name](start); } };
  const ruhig = () => { let p = null; try { p = localStorage.getItem('akk-motion'); } catch (e) { /* egal */ } return p ? p === 'off' : matchMedia('(prefers-reduced-motion: reduce)').matches; };

  const track = (name, d) => {
    (window.AKE_LOG = window.AKE_LOG || []).push([name, d]);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) { /* Messung darf nie stören */ }
  };

  /* ---------- 1. Countdown ---------- */
  const t = root.querySelector('[data-ake-tage]');
  if (t) {
    let heute;
    try { heute = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { heute = new Date().toISOString().slice(0, 10); }
    const n = Math.round((Date.parse(t.dataset.akeTage) - Date.parse(heute)) / 864e5);
    if (n === 1) t.textContent = 'morgen';
    else if (n > 1) t.textContent = 'in ' + n + ' Tagen';
    else if (n === 0) t.textContent = 'heute';
  }

  /* ---------- 2. Anlass-Dialoge ---------- */
  const cssGeladen = {};
  function ladeLink(href) {
    if (!href) return Promise.resolve();
    if (cssGeladen[href]) return cssGeladen[href];
    if (document.querySelector('link[href="' + href + '"]')) return (cssGeladen[href] = Promise.resolve());
    const n = document.createElement('link');
    n.rel = 'stylesheet'; n.href = href;
    cssGeladen[href] = new Promise((ok) => { n.onload = n.onerror = ok; setTimeout(ok, 2500); });
    document.head.append(n);
    return cssGeladen[href];
  }
  // CSS des Anlasses (Teil „css“ im <template>) und der Interaktion (data-akan-css am Dialog, z. B. Quiz-Baustein)
  function ladeCss(id) {
    const tpl = root.querySelector('template[data-ake-css="' + id + '"]');
    const dlg = root.querySelector('template[data-ake-dlg="' + id + '"]');
    const hrefs = tpl ? [...tpl.content.querySelectorAll('link[href]')].map((l) => l.getAttribute('href')) : [];
    const d = dlg && dlg.content.querySelector('dialog[data-akan-css]');
    if (d) hrefs.push(d.getAttribute('data-akan-css'));
    return Promise.all(hrefs.map(ladeLink));
  }

  let offen = null;
  async function oeffne(id, ansicht, ausloeser, slot) {
    const tpl = root.querySelector('template[data-ake-dlg="' + id + '"]');
    if (!tpl || offen) return;
    await ladeCss(id);
    const dlg = tpl.content.querySelector('dialog').cloneNode(true);
    dlg.querySelectorAll('[commandfor]').forEach((b) => { b.removeAttribute('command'); b.removeAttribute('commandfor'); });
    document.body.append(dlg);
    offen = dlg;
    const segs = dlg.querySelectorAll('.akan-seg [data-akan-ansicht]');
    const platz = dlg.querySelector('[data-akan-slot]');
    const sende = (name, p) => track(name, Object.assign({ erlebnis_id: id, erlebnis_art: 'anlass', quelle: 'hub' }, p || {}));
    const fokusZiel = (v) => (v === 'mitmachen' && dlg.querySelector('[data-akan-fokus]:not([hidden])')) || dlg.querySelector('#akan-h');
    let laden = null;
    const lade = () => {
      if (!platz || !dlg.dataset.akanJs) return Promise.resolve();
      if (laden) return laden;
      laden = new Promise((fertig) => {
        const name = platz.dataset.akanSlot;
        const start = (fn) => {
          let daten = {};
          try { daten = JSON.parse((dlg.querySelector('[data-akan-daten]') || {}).textContent || '{}'); } catch (e) { /* leere Daten */ }
          platz.textContent = '';
          try { fn(platz, { daten, dialog: dlg, ruhig, klein: () => matchMedia('(max-width: 899px), (max-height: 779px)').matches, track: (n, p) => sende('akan_' + n, p) }); }
          catch (e) { platz.innerHTML = '<p class="akan-play__wait">Das Experiment konnte nicht starten. Bitte lade die Seite neu.</p>'; if (window.console) console.error('[ake]', e); }
          fertig();
        };
        if (AKAN._reg[name]) { start(AKAN._reg[name]); return; }
        AKAN._warte[name] = start;
        const s = document.createElement('script');
        s.src = dlg.dataset.akanJs; s.async = true;
        s.onerror = () => { platz.innerHTML = '<p class="akan-play__wait">Das Experiment ließ sich nicht laden. Bitte lade die Seite neu.</p>'; fertig(); };
        document.head.append(s);
      });
      return laden;
    };
    const zeige = (v) => {
      if (!platz) v = 'geschichte';
      dlg.dataset.ansicht = v;
      segs.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.akanAnsicht === v)));
      dlg.querySelectorAll('.akan-story,.akan-play').forEach((p) => { p.scrollTop = 0; });
      requestAnimationFrame(() => { const z = fokusZiel(v); if (z) z.focus({ preventScroll: true }); });
      dlg.dispatchEvent(new CustomEvent('akan:auf', { detail: { ansicht: v } }));
      lade().then(() => {
        if (dlg.open && v === 'mitmachen' && dlg.dataset.ansicht === 'mitmachen') { const z = fokusZiel(v); if (z && document.activeElement !== z) z.focus({ preventScroll: true }); }
        dlg.dispatchEvent(new CustomEvent('akan:auf', { detail: { ansicht: v } }));
      });
    };
    const zu = () => {
      if (!dlg.open) return;
      if (ruhig()) { dlg.close(); return; }
      dlg.classList.add('is-closing');
      setTimeout(() => { dlg.classList.remove('is-closing'); dlg.close(); }, 170);
    };
    dlg.addEventListener('close', () => {
      de.classList.remove('akan-lock');
      dlg.remove();
      offen = null;
      if (ausloeser && ausloeser.isConnected) ausloeser.focus({ preventScroll: true });
    });
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); zu(); });
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) return zu();
      if (e.target.closest('[data-akan-zu]')) return zu();
      const b = e.target.closest('[data-akan-ansicht]');
      if (b) { zeige(b.dataset.akanAnsicht); return; }
      const a = e.target.closest('a');
      if (a && a.hasAttribute('data-akan-produkt')) sende('akan_produkt_klick', { ziel: a.dataset.akanProdukt });
      else if (a && a.hasAttribute('data-akan-quelle')) sende('akan_quelle_klick', { link_url: a.href });
    });
    dlg.showModal();
    de.classList.add('akan-lock');
    sende('select_promotion', { promotion_id: 'anlass-' + id, creative_slot: slot, ziel: ansicht });
    sende('akan_dialog_auf', { ansicht });
    zeige(ansicht);
  }

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-akan-auf]');
    if (b && root.contains(b)) {
      const karte = b.closest('[data-ake-anlass]');
      if (!karte) return;
      e.preventDefault();
      oeffne(karte.dataset.akeAnlass, b.dataset.akanAuf, b, karte.closest('[data-ake-now]') ? 'hub-heute' : 'hub-archiv');
      return;
    }
    const a = e.target.closest('a[data-ake-ziel]');
    if (a) track('ake_karte_klick', { erlebnis_id: 'akkunaut-welt', erlebnis_art: 'hub', ziel: a.dataset.akeZiel });
  });
  // Experiment-Skript schon beim Zeigen auf einen Auslöser vorbereiten: CSS vorladen
  root.addEventListener('pointerover', (e) => { const k = e.target.closest('[data-akan-auf]') && e.target.closest('[data-ake-anlass]'); if (k) ladeCss(k.dataset.akeAnlass); }, { passive: true });

  // Ansicht der Seite einmal melden (für die Zählung der Besuche im Hub)
  track('ake_hub_ansicht', { erlebnis_id: 'akkunaut-welt', erlebnis_art: 'hub', archiv: root.querySelectorAll('[data-ake-anlass]').length });
})();
